import { GENERAL_ELECTRIC } from '@/constants/integrationTypes';

export const volumeOptions = [
    { value: '0|100', label: '0 - 100' },
    { value: '100|200', label: '100 - 200' },
    { value: '200|300', label: '200 - 300' },
    { value: '300|400', label: '300 - 400' },
    { value: '400|500', label: '400 - 500' },
    { value: '500|9999999', label: '500 +' },
];

export const distanceOptions = [
    { value: '0|5', label: '0 - 5' },
    { value: '5|10', label: '5 - 10' },
    { value: '10|25', label: '10 - 25' },
    { value: '25|50', label: '25 - 50' },
    { value: '50|100', label: '50 - 100' },
    { value: '100|9999999', label: '100 +' },
];

export const scheduledOptions = [
    { value: 'All', label: 'All' },
    { value: 'Scheduled', label: 'Scheduled' },
    { value: 'Unscheduled', label: 'Unscheduled' },
];

export const middleMileOptions = [
    { value: 'ALL', label: 'All' },
    { value: 'NONE', label: 'No Status / Status Unknown' },
    { value: 'PENDING', label: 'Pending' },
    { value: 'SCHEDULED', label: 'Scheduled' },
    { value: 'IN_TRANSIT', label: 'In Transit' },
    { value: 'ARRIVED', label: 'Arrived' },
    { value: 'CANCELLED', label: 'Cancelled' },
];

export const wh_statuses = [
    { value: 'RECEIVED', label: 'Received' },
    { value: 'NOT_DELIVERED', label: 'Not Received' },
];

export const order_types = [
    { value: 'delivery', label: 'Delivery' },
    { value: 'return', label: 'Return' },
    { value: 'exchange', label: 'Exchange' },
    { value: 'service', label: 'Service Callback' },
    { value: 'will_call', label: 'Will Call' },
    { value: 'wh_inventory', label: 'Inventory' },
];

export const dispatch_integration_types = [
    { value: 'ALL', label: 'All' },
    { value: 'NONE', label: 'No TMS' },
    { value: 'DISPATCHTRACK', label: 'DispatchTrack' },
    { value: 'GRASSHOPPER', label: 'Grasshopper' },
    { value: 'FLEETENABLE', label: 'FleetEnable' },
    { value: GENERAL_ELECTRIC, label: 'General Electric' },
    { value: 'XCELERATOR_AXIS', label: 'Xcelerator' },
    { value: 'IDLS', label: 'IDLS' },
    { value: 'RYDER', label: 'Ryder' },
    { value: 'FRAYT', label: 'Frayt' },
    { value: 'BUNGII', label: 'Bungii' },
    { value: 'CURRI', label: 'Curri' },
    { value: 'DISPATCHIT', label: 'Dispatch' },
    { value: 'CXT_API', label: 'Elite Transportation Systems' },
];
